import graphql from "babel-plugin-relay/macro";

export const OverridePolicyQuery = graphql`
  query OverridePolicyQuery($documentPk: Int!) {
    documentOverride(pk: $documentPk) {
      document {
        ...commentForm_document
        id
        pk
        name
        status
        actions(isEditPage: false) {
          id
          pk
          actionType
          actionDate
          comment
          canEdit
          isExternal
          user {
            id
            userDisplay(userDisplayType: FORWARD)
          }
        }
      }
      editForm {
        name
        author {
          pk
          firstName
          lastName
          title
        }
        category {
          pk
          name
        }
        categoryChoices {
          pk
          name
        }
        flowTemplate {
          pk
          name
        }
        flowTemplateChoices {
          pk
          name
        }
        bloc {
          pk
          name
        }
        blocChoices {
          pk
          name
        }
        html
        activeLifespan
        expirationDate
        isAForm
        restricted
        legacyEffectiveDate
        approvalDate
        regulations
      }
      tagForm {
        tags {
          pk
          name
        }
      }
      scheduledEffectiveDateForm {
        effectiveDate
        effectiveDateTimedelta
        effectiveDateAlgorithm
        originationDate
      }
      preimportRevisionForm {
        revisionDates
      }
      error {
        statusCode
        message
      }
      tenantsToRedirect {
        name
        url
      }
      rtlSupport
      newCkeditor
      redirectUrl
      policyActions
    }
  }
`;

export default OverridePolicyQuery;
